import React, { FC, useState } from "react";
import { Box, Typography, IconButton } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";

import CustomModal from "../../common/custom-modal/custom-modal";
import { Colors } from "../../../configs";
import { pxToRem } from "../../../util";
import creditCardIcon from "../../../assets/images/creditCard.svg";

export interface UpdateCardsModalProps {
  open: boolean;
  onClose(): void;
  cards?: Array<{
    id: string;
    number: string;
    expiry: string;
    isDefault: boolean;
  }>;
}

const CreditCardIcon: FC = () => (
  <img src={creditCardIcon} alt="Credit Card" width={120} height={80} />
);

const CheckmarkIcon: FC = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.02115 2.783C9.07051 2.56094 9.19411 2.36234 9.37155 2.21999C9.54899 2.07764 9.76966 2.00004 9.99715 2H13.9971C14.2246 2.00004 14.4453 2.07764 14.6227 2.21999C14.8002 2.36234 14.9238 2.56094 14.9731 2.783L15.4131 4.764C15.8131 4.954 16.1931 5.174 16.5531 5.424L18.4911 4.814C18.7082 4.74577 18.9419 4.75356 19.1539 4.8361C19.3659 4.91864 19.5434 5.07099 19.6571 5.268L21.6571 8.732C21.7709 8.92904 21.8141 9.159 21.7796 9.3839C21.745 9.6088 21.6348 9.81519 21.4671 9.969L19.9701 11.342C20.0063 11.7799 20.0063 12.2201 19.9701 12.658L21.4671 14.031C21.6348 14.1848 21.745 14.3912 21.7796 14.6161C21.8141 14.841 21.7709 15.071 21.6571 15.268L19.6571 18.732C19.5434 18.929 19.3659 19.0814 19.1539 19.1639C18.9419 19.2464 18.7082 19.2542 18.4911 19.186L16.5541 18.576C16.1941 18.826 15.8141 19.046 15.4141 19.236L14.9741 21.216C14.9249 21.4384 14.8013 21.6374 14.6236 21.7799C14.446 21.9225 14.2249 22.0001 13.9971 22H9.99715C9.76966 22 9.54899 21.9224 9.37155 21.78C9.19411 21.6377 9.07051 21.4391 9.02115 21.217L8.58115 19.236C8.18115 19.046 7.80115 18.826 7.44115 18.576L5.50315 19.186C5.28614 19.2542 5.05235 19.2464 4.84037 19.1639C4.62838 19.0814 4.45088 18.929 4.33715 18.732L2.33715 15.268C2.22336 15.071 2.18017 14.841 2.21472 14.6161C2.24926 14.3912 2.35947 14.1848 2.52715 14.031L4.02415 12.658C3.98801 12.2201 3.98801 11.7799 4.02415 11.342L2.52715 9.97C2.35947 9.81619 2.24926 9.6098 2.21472 9.3849C2.18017 9.16 2.22336 8.93004 2.33715 8.733L4.33715 5.269C4.45088 5.07199 4.62838 4.91964 4.84037 4.8371C5.05235 4.75456 5.28614 4.74677 5.50315 4.815L7.44015 5.425C7.80015 5.175 8.18015 4.955 8.58015 4.765L9.02015 2.785L9.02115 2.783ZM15.7041 10.707C15.8863 10.5184 15.9871 10.2658 15.9848 10.0036C15.9825 9.7414 15.8774 9.49059 15.692 9.30518C15.5066 9.11977 15.2557 9.0146 14.9935 9.01233C14.7314 9.01005 14.4788 9.11084 14.2901 9.293L10.9971 12.586L9.70415 11.293C9.51554 11.1108 9.26294 11.01 9.00075 11.0123C8.73855 11.0146 8.48774 11.1198 8.30233 11.3052C8.11692 11.4906 8.01175 11.7414 8.00947 12.0036C8.00719 12.2658 8.10799 12.5184 8.29015 12.707L10.2901 14.707C10.4777 14.8945 10.732 14.9998 10.9971 14.9998C11.2623 14.9998 11.5166 14.8945 11.7041 14.707L15.7041 10.707Z"
      fill={Colors.PRIMARY}
    />
  </svg>
);

export const TrashIcon: FC = () => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_10745_12918)">
      <path
        d="M2.5885 5.73938V16.2338C2.5885 16.811 3.06075 17.2832 3.63794 17.2832H13.0829C13.6601 17.2832 14.1323 16.811 14.1323 16.2338V5.73938H2.5885ZM5.73682 15.1843H4.68738V7.83826H5.73682V15.1843ZM7.8357 15.1843H6.78626V7.83826H7.8357V15.1843ZM9.93457 15.1843H8.88513V7.83826H9.93457V15.1843ZM12.0335 15.1843H10.984V7.83826H12.0335V15.1843ZM14.3947 2.59107H10.984V1.27927C10.9832 1.07078 10.9 0.87106 10.7526 0.723634C10.6051 0.576207 10.4054 0.493017 10.1969 0.492188L6.5239 0.492188C6.31541 0.493017 6.11569 0.576207 5.96826 0.723634C5.82084 0.87106 5.73765 1.07078 5.73682 1.27927V2.59107H2.32614C2.1174 2.59107 1.9172 2.67399 1.76959 2.8216C1.62199 2.9692 1.53906 3.1694 1.53906 3.37814V4.68994H15.1818V3.37814C15.1818 3.1694 15.0988 2.9692 14.9512 2.8216C14.8036 2.67399 14.6034 2.59107 14.3947 2.59107ZM9.93457 2.59107H6.78626V1.55527H9.93457V2.59107Z"
        fill="#930000"
      />
    </g>
    <defs>
      <clipPath id="clip0_10745_12918">
        <rect
          width="16.791"
          height="16.791"
          fill="white"
          transform="translate(0.492188 0.492188)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const EditIcon: FC = () => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.48682 3.28988H5.52787C4.74428 3.28988 4.35249 3.28988 4.05305 3.4424C3.78978 3.57654 3.57573 3.79059 3.44158 4.05387C3.28906 4.35331 3.28906 4.7451 3.28906 5.52868V12.2451C3.28906 13.0287 3.28906 13.4205 3.44158 13.7199C3.57573 13.9832 3.78978 14.1972 4.05305 14.3314C4.35179 14.4839 4.74358 14.4839 5.52577 14.4839H12.2464C13.0286 14.4839 13.4196 14.4839 13.7184 14.3314C13.9821 14.197 14.1962 13.983 14.3306 13.7199C14.4831 13.4205 14.4831 13.0294 14.4831 12.2472V10.2861M11.6846 3.9895L7.48682 8.18726V10.2861H9.5857L13.7835 6.08838M11.6846 3.9895L13.7835 1.89062L15.8823 3.9895L13.7835 6.08838M11.6846 3.9895L13.7835 6.08838"
      stroke={Colors.PRIMARY}
      strokeWidth="1.39925"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const UpdateCardsModal: FC<UpdateCardsModalProps> = ({
  open,
  onClose,
  cards = [
    {
      id: "1",
      number: "XXXX XXXX XXXX 7896",
      expiry: "11/26",
      isDefault: true,
    },
    {
      id: "2",
      number: "XXXX XXXX XXXX 1234",
      expiry: "09/27",
      isDefault: false,
    },
  ],
}) => {
  const [currentCardIndex, setCurrentCardIndex] = useState(0);
  const [cardData, setCardData] = useState(cards);

  const handlePrevious = () => {
    setCurrentCardIndex((prev) => 
      prev === 0 ? cardData.length - 1 : prev - 1
    );
  };

  const handleNext = () => {
    setCurrentCardIndex((prev) => 
      prev === cardData.length - 1 ? 0 : prev + 1
    );
  };

  const renderCardDetailsView = () => {
    const currentCard = cardData[currentCardIndex];

    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
          width: "100%",
          padding: "1.5rem",
          boxSizing: "border-box",
        }}
      >
        <Box
          sx={{
            border: `2px solid ${Colors.PRIMARY}`,
            borderRadius: pxToRem(25),
            padding: "0rem",
            backgroundColor: Colors.WHITE,
            display: "flex",
            flexDirection: "column",
            height: "100%",
            width: "100%",
            maxWidth: pxToRem(700),
            minHeight: pxToRem(320),
            position: "relative",
            marginBottom: pxToRem(40),
            overflow: "hidden",
          }}
        >
          {/* Checkmark Icon */}
          <Box
            sx={{
              position: "absolute",
              top: pxToRem(8),
              left: pxToRem(8),
              width: pxToRem(24),
              height: pxToRem(24),
            }}
          >
            <CheckmarkIcon />
          </Box>

          {/* Card Number */}
          <Box
            sx={{
              backgroundColor: Colors.BACKSHADE_GRAY,
              borderRadius: pxToRem(8),
              padding: "1rem 1.5rem",
              marginTop: "6rem",
              marginBottom: "1rem",
              width: "100%",
              boxSizing: "border-box",
            }}
          >
            <Typography
              sx={{
                color: Colors.TEXT_GRAY_DARK,
                fontSize: pxToRem(20),
                fontWeight: "500",
                textAlign: "center",
                letterSpacing: "2px",
              }}
            >
              {currentCard.number}
            </Typography>
          </Box>

          {/* Expiry Date */}
          <Typography
            sx={{
              color: Colors.TEXT_GRAY_DARK,
              fontSize: pxToRem(20),
              fontWeight: "500",
              marginTop: "1.5rem",
              marginBottom: "1.5rem",
              marginLeft: "8rem",
            }}
          >
            Exp: {currentCard.expiry}
          </Typography>

          {/* Bottom Section */}
          <Box
            sx={{
              backgroundColor: Colors.BACKSHADE_GRAY,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "2rem 0.5rem",
              width: "100%",
              marginTop: "auto",
              position: "relative",
            }}
          >
          </Box>

          {/* Credit Card Icon */}
          <Box
            sx={{
              width: pxToRem(140),
              height: pxToRem(100),
              display: "flex",
              alignItems: "flex-end",
              justifyContent: "flex-end",
              position: "absolute",
              right: 0,
              bottom: pxToRem(0),
              paddingBottom: "1rem",
              paddingRight: "0.5rem",
            }}
          >
            <Box
              sx={{
                transform: "scale(0.8)",
                transformOrigin: "center",
              }}
            >
              <CreditCardIcon />
            </Box>
          </Box>
        </Box>
      </Box>
    );
  };

  return (
    <CustomModal
      title=""
      openModal={open}
      width={pxToRem(650)}
      height={pxToRem(440)}
      onClose={onClose}
    >
      <Box
        sx={{
          position: "relative",
          height: "100%",
          width: "100%",
          pb: 1.5,
        }}
      >
        {/* Navigation Arrows */}
        <IconButton
          onClick={handlePrevious}
          sx={{
            position: "absolute",
            left: pxToRem(-40),
            top: "40%",
            transform: "translateY(-50%)",
            zIndex: 10,
            backgroundColor: Colors.BACKSHADE_GRAY,
            borderRadius: pxToRem(4),
            width: pxToRem(50),
            height: pxToRem(50),
            padding: 0,
            "&:hover": {
              backgroundColor: Colors.BACKGROUND_GRAY,
            },
          }}
        >
          <ChevronLeft />
        </IconButton>

        <IconButton
          onClick={handleNext}
          sx={{
            position: "absolute",
            right: pxToRem(-40),
            top: "40%",
            transform: "translateY(-50%)",
            zIndex: 10,
            backgroundColor: Colors.BACKSHADE_GRAY,
            borderRadius: pxToRem(4),
            width: pxToRem(50),
            height: pxToRem(50),
            padding: 0,
            "&:hover": {
              backgroundColor: Colors.BACKGROUND_GRAY,
            },
          }}
        >
          <ChevronRight />
        </IconButton>

        {/* Content */}
        {renderCardDetailsView()}
      </Box>
    </CustomModal>
  );
};

export default UpdateCardsModal;